import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      <div className="about-content">
        <h1>About ANTI-STYLE HYPOTHESIS</h1>
        <div className="about-text">
          <p>
            ANTI-STYLE HYPOTHESIS curates authentic vintage clothing from 1950-2000,
            selecting pieces that embody the genuine wear, fading, and character that comes
            with time and real use.
          </p>
          <p>
            We believe in the authenticity of vintage fashion - the subtle signs of wear,
            the natural fading, the stories embedded in each garment. Our collection
            honors the true essence of vintage: pieces that have lived, loved, and evolved
            through decades of wear and care.
          </p>
          <p>
            Each garment in our curated selection tells its own story of time and transformation.
            We're not just selling clothes - we're preserving pieces of fashion history that
            continue to inspire and influence contemporary style with their genuine character.
          </p>
        </div>

        <div className="stats">
          <div className="stat">
            <h2>400+</h2>
            <p>Vintage Items</p>
          </div>
          <div className="stat">
            <h2>25+</h2>
            <p>Years of Style</p>
          </div>
          <div className="stat">
            <h2>100%</h2>
            <p>Authentic</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
